import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import Navbar from '../components/Navbar';
import Slider from '../components/Slider';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

import Image5 from "../images/slider/5.jpg";
import Image6 from "../images/slider/6.jpg";

import { courses } from '../lib/data';
import { nigerianCurrency } from '../lib/formatter';

const IMAGES = [Image5, Image6];

const AcademyPage = () => {
    const location = useLocation();
    const home = useRef(null);

    useEffect(() => {
        if (location.hash === '#home' && home.current) {
            home.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);

    return (
        <div>
            {/* Navigation */}
            <Navbar />

            {/* start home */}
            <section id="home" ref={home}>
                <div className="overlay">
                    <Slider imageUrls={IMAGES} academy />
                </div>
            </section>
            {/* end home  */}


            {/* start body-wrap  */}
            <section id='body-wrap'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 wow bounceIn">
                            <h2 className="text-uppercase">BRAINYTECH ACADEMY</h2>
                            <hr />
                            <h4 className="contact-style">We equip aspiring developers with IT skills for the modern market, via online courses. Our tutors are professionals with more than seven years of experience in the industry. <b style={{ color: '#55acee' }}>ENROLL NOW!!</b></h4>
                        </div>
                    </div>

                    <div className="row">
                        {
                            courses.map(course => (
                                <div className="col-md-4 col-sm-6 wow fadeInLeft brainytech-about-left" data-wow-delay="0.3s">
                                    <div className='course'>
                                        <div className='course-image'>
                                            {
                                                course.imgURL.startsWith("https") ? (
                                                    <img src={course.imgURL} alt={`${course.name.split(" - ")[0]} pics`} />
                                                ) : (
                                                    <img src={process.env.PUBLIC_URL + course.imgURL} alt={`${course.name.split(" - ")[0]} pics`} />
                                                )
                                            }
                                        </div>
                                        <div className='course-content'>
                                            <div className='academy-info'>
                                                <img src={`${process.env.PUBLIC_URL}/images/logo-only.png`} alt="Logo" />
                                                <span>Brainytech Academy</span>
                                            </div>

                                            <div className='course-info'>
                                                <h3>{course.name.split(" - ")[0]}</h3>
                                                <p>
                                                    {`${course.description.slice(0, 120)}...`}

                                                    {course.ready === true ? (
                                                        <Link className='course-link' to={`/academy/course/${course.id}`}> See Course Content 📚</Link>
                                                    ) : (
                                                        <Link className='course-link'> Preparing Content 📚</Link>
                                                    )}
                                                </p>

                                                {
                                                    course.ready === true ? (
                                                        course.discountedPrice ? (
                                                            <>
                                                                <p className='course-price'>
                                                                    <b>Price:</b><span className='canceled-price'>{nigerianCurrency.format(course.price)}</span> <b>{nigerianCurrency.format(course.discountedPrice)}</b>
                                                                </p>

                                                                <p className='limited-offer'>
                                                                    ({(course.price - course.discountedPrice) / course.price * 100}% OFF  FOR A LIMITED TIME ONLY)
                                                                </p>
                                                            </>
                                                        ) : (
                                                            <p className='course-price'>
                                                                <b>Price: </b> {nigerianCurrency.format(course.price)}
                                                            </p>
                                                        )
                                                    ) : (
                                                        <>
                                                            <p className='course-price'>
                                                                <b>Price: N/A </b>
                                                            </p>

                                                            <p className='limited-offer'>
                                                                (YET TO BE DETERMINED)
                                                            </p>
                                                        </>
                                                    )
                                                }

                                                <p><b>Duration:</b> {course.snippets.duration}</p>
                                                {course.ready === false ? (
                                                    <button className='btn-enroll' disabled>   <a href="https://forms.gle/yzfdeDki6QaSvDv19">COMING SOON</a></button>
                                                ) : (
                                                    <button className='btn-enroll'>   <a href="https://forms.gle/yzfdeDki6QaSvDv19">ENROLL</a></button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>

                </div >
            </section >
            {/* end body-wrap  */}

            {/* contact  */}
            <Contact />

            {/* Footer */}
            <Footer />
        </div >
    )
}

export default AcademyPage